










































































































import { Component, Prop, State, Vue } from 'nuxt-property-decorator';
import ToastService, { ToastType } from './toast/ToastService';
import TooltipButton from './TooltipButton.vue';
import { SidePanelMode } from './side-panel/SidePanelMode';
import PageAndChapterDetailsActions from './page-and-chapter-details/PageAndChapterDetailsActions.vue';
import PageDetails from './page-and-chapter-details/PageDetails.vue';
import ShareDetails from './share/shareDetails.vue';
import ChapterDetails from './page-and-chapter-details/ChapterDetails.vue';
import { ReadingMode } from './read-aloud/library/models';
import { NotesMode } from './side-panel/notes/NotesMode';
import { ICite } from './page-and-chapter-details/CiteReferenceButton.vue';
import CiteReferenceModal from './page-and-chapter-details/CiteReferenceModal.vue';
import NotesStore from '@/store/notes.store';
import ReadAloudStore from '@/components/ui/read-aloud/library/read-aloud.store';
import CeDynamic from '~/components/typo3-library-overrides/common/CeDynamic.vue';
import CeExtendedCmsGroup from '~/components/typo3-library-overrides/common/CeExtendedCmsGroup.vue';
import KeyHandleEventBus from '@/store/keyHandle.eventbus';
import SidePanelStore from '@/components/ui/side-panel/side-panel.store';
import { Metadata } from '@/types/initialData';
import { WEBHL_WRAPPER_TAG } from '@/store/webHighlighter.store';

@Component({
  components: {
    CiteReferenceModal,
    ChapterDetails,
    PageDetails,
    ShareDetails,
    PageAndChapterDetailsActions,
    TooltipButton
  }
})
export default class HeaderUtils extends Vue {
  // @ts-ignore
  @State((state) => state.typo3?.initial?.site?.metadata?.links?.site)
  siteLink: string;

  // @ts-ignore
  @State((state) => !!state.typo3?.initial?.site?.user?.info?.id)
  isLoggedIn: boolean;

  // @ts-ignore
  @State((state) => state.typo3?.initial?.site?.metadata)
  metadata!: Metadata;

  // @ts-ignore
  @State((state) => state.typo3?.page?.page?.meta?.author)
  author!: string;

  @Prop({ type: Boolean, default: false })
  sharePage!: boolean;

  showContextMenu: boolean = false;
  chapterDetailsActive: boolean = false;
  pageDetailsActive: boolean = false;
  shareDetailsActive: boolean = false;
  citeReferenceActive: boolean = false;
  locationHost: string = window.location.host;
  baseUrl: string = `https://${this.locationHost}`;
  cite: string | ICite = '';

  @Prop({ type: Number, default: null })
  cId!: number;

  get noOtherPanelsOpen(): boolean {
    return (
      !this.pageDetailsActive &&
      !this.shareDetailsActive &&
      !this.chapterDetailsActive &&
      !this.citeReferenceActive
    );
  }

  get handleButtonState(): string {
    return this.showContextMenu
      ? 'v-btn--header-utils v-btn--active'
      : 'v-btn--header-utils';
  }

  get uniqueId(): string {
    // uid is from https://www.npmjs.com/package/vue-unique-id
    // We are not allowed to use the _uid from vue
    return this.uid;
  }

  get sectionUrl(): string {
    return this.$route.hash
      ? `${this.baseUrl}/?id=${this.$route.query.id}#c${this.cId}`
      : `${this.baseUrl}${this.$route.fullPath}#c${this.cId}`;
  }

  get pageUrl(): string {
    return `${this.baseUrl}${this.$route.fullPath}`;
  }

  get urlToCopy(): string {
    return this.sharePage ? this.pageUrl : this.sectionUrl;
  }

  mounted() {
    KeyHandleEventBus.$on('escape', this.closeContextMenu);
  }

  beforeDestroy() {
    KeyHandleEventBus.$off('escape', this.closeContextMenu);
  }

  handleContextMenuState(): void {
    if (this.showContextMenu) {
      this.closeContextMenu();
    } else {
      this.showContextMenu = true;
    }
  }

  showPageDetails(): void {
    this.pageDetailsActive = true;
  }

  showShareDetails(): void {
    this.shareDetailsActive = true;
  }

  showChapterDetails(): void {
    this.chapterDetailsActive = true;
  }

  handleCiteReference(cite: ICite): void {
    this.cite = cite;
    this.citeReferenceActive = true;
    this.closeDetails();
  }

  closeDetails(): void {
    this.pageDetailsActive = false;
    this.chapterDetailsActive = false;
  }

  closeShareDetails(): void {
    this.shareDetailsActive = false;
  }

  closeContextMenu(): void {
    this.showContextMenu = false;
    this.citeReferenceActive = false;
    this.closeDetails();
  }

  copyUrlSuccess({ value }) {
    if (value) {
      ToastService.showToast(
        this.$i18n.t('labels.headerActionsMenu.link-copy') as string
      );
    }
  }

  initReadAloud(): void {
    const internalReadingMode = this.sharePage
      ? ReadingMode.Document
      : ReadingMode.Section;

    if (internalReadingMode === ReadingMode.Document) {
      ReadAloudStore.readingMode = internalReadingMode;
    }

    if (internalReadingMode === ReadingMode.Section) {
      // We set the range when the parent is expanded
      ReadAloudStore.startSectionId = this.cId;
      this.openParentIfClosed(this.$parent);
      ReadAloudStore.readingMode = internalReadingMode;
    }

    ReadAloudStore.playerShowing = true;

    this.closeContextMenu();
  }

  createNote(): void {
    const range = new Range();
    const headerSelector = this.sharePage
      ? '#js-page-title-header'
      : '.ce-header__primary';
    const domHeader = this.$parent.$el.querySelector(headerSelector);
    if (domHeader.getElementsByTagName(WEBHL_WRAPPER_TAG).length > 0) {
      ToastService.showToast(
        this.$i18n.t(
          'labels.notes.warnings.invalid-selection-double'
        ) as string,
        ToastType.Warning
      );
      return;
    }

    const cId: number = this.cId ? this.cId : 0;
    range.selectNode(domHeader);
    document.getSelection().removeAllRanges();
    document.getSelection().addRange(range);
    NotesStore.temporarySelectionState = {
      ranges: [],
      selection: undefined,
      concatinatedTextSelection: '',
      range,
      selectionCId: `c${cId}`
    };
    //
    NotesStore.userCanCreateHighlight = true;
    HeaderUtils.openSidePanelCreateNote();

    this.closeContextMenu();
  }

  private static openSidePanelCreateNote(): void {
    SidePanelStore.mode = SidePanelMode.NOTES;
    NotesStore.setNotesMode(NotesMode.CREATE);
    SidePanelStore.rightPanelIsOpen = true;
  }

  private openParentIfClosed(parent: Vue): void {
    if (!parent) {
      return;
    }

    const id = parent.$el.id;

    if (
      id &&
      id.startsWith('c') &&
      Number(id.substring(1, id.length) !== Number.NaN)
    ) {
      if (parent instanceof CeDynamic || parent instanceof CeExtendedCmsGroup) {
        if (!parent.isExpanded) {
          parent.isExpanded = true;
        }
        parent.$nextTick(this.notifyReadAloud);
      }
    } else {
      this.openParentIfClosed(parent.$parent);
    }
  }

  private notifyReadAloud(): void {
    const cId = `c${this.cId}`;
    const section = document.getElementById(cId);
    const range = document.createRange().cloneRange();
    range.setStart(section, 0);
    range.setEnd(section, 3);

    ReadAloudStore.notifyReadAloud(range);

    document.getSelection().removeAllRanges();
  }
}
